import { render } from "./RegisterExpressView.vue?vue&type=template&id=7c07d9d6"
import script from "./RegisterExpressView.vue?vue&type=script&lang=js"
export * from "./RegisterExpressView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__